import store from '@/store'

export function addAttributes(sessions) {
  let group = [];
  let overlappings = {};
  for (let i = 0; i < sessions.length; i++) {
    let session = sessions[i];
    let matching = true;
    const items = [session].concat(Array.isArray(session.children) ? session.children : []);
    const filterIds = ids => ids.map(String);
    const hasGroupMatch = ids => {
      if (!ids.length) return true;
      const filter = filterIds(ids);
      return items.some(item => {
        const groups = Array.isArray(item.session_groups) ? item.session_groups : [];
        return groups.some(g => g && filter.includes(String(g.id)));
      });
    };
    const hasTypeMatch = ids => {
      if (!ids.length) return true;
      const filter = filterIds(ids);
      return items.some(item => item.session_type && filter.includes(String(item.session_type.id)));
    };
    const hasRoomMatch = ids => {
      if (!ids.length) return true;
      const filter = filterIds(ids);
      return items.some(item => item.room && filter.includes(String(item.room.id)));
    };
    if (!hasGroupMatch(store.state.filter.session_group)) {
      matching = false;
    }
    if (!hasTypeMatch(store.state.filter.session_type)) {
      matching = false;
    }
    if (!hasRoomMatch(store.state.filter.room)) {
      matching = false;
    }
    session.matching = matching;
    if (session.type === null) {
      session.type = { value: { color: '#000000', background: '#ffffff' }};
    }
    let overlap = sessions.find(session => 
      session.id != session.id 
      && session.day_id === session.day_id 
      && session.room_id === session.room_id 
      && !(session.end_time_timestamp <= session.start_time_timestamp || session.start_time_timestamp >= session.end_time_timestamp)
    );
    if (overlap !== undefined) {
      if (!group.includes(overlap.id)) group.push(overlap.id);
      if (!group.includes(session.id)) group.push(session.id);
    } else {
      for (let j = 0; j < group.length; j++) overlappings[parseInt(group[j])] = group.length;
      group = [];
    }
    if ((i + 1) === sessions.length) {
      for (let j = 0; j < group.length; j++) overlappings[parseInt(group[j])] = group.length;
    }
  }
  for (let i = 0; i < sessions.length; i++) {
    let session = sessions[i];
    session.overlaps = Object.prototype.hasOwnProperty.call(overlappings, session.id)
      ? overlappings[session.id]
      : 1;
  }
  return sessions;
}
